exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-module {\n  position: relative; }\n  .search-module input {\n    width: 100%;\n    border-color: transparent;\n    margin: 6px auto; }\n  .search-module .search-suggestions {\n    margin-top: -6px;\n    position: absolute;\n    width: 100%;\n    z-index: 2;\n    background-color: white;\n    box-shadow: 1px 2px 16px #c7c8ca;\n    z-index: 401; }\n    .search-module .search-suggestions ul > li:not(:last-child) {\n      border-bottom: 1px solid #c7c8ca; }\n    .search-module .search-suggestions ul > li a {\n      padding: none;\n      padding: unset; }\n      .search-module .search-suggestions ul > li a span {\n        display: block;\n        margin-left: none;\n        margin-left: unset;\n        padding: 12px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/search-input.component.scss
// module id = ../../../../../src/app/common/search-input.component.scss
// module chunks = main